import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { MaskInput, TextareaInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type ExtraProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export function Extra({ disabled, skeletonShow }: ExtraProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('additional information')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <TextInput
            label='form.residential address'
            name='placeOfResidence'
            placeholder='form.enter residential address'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.feedback'
            name='data.comment'
            placeholder='form.enter feedback'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.last workplace'
            name='data.lastJob'
            placeholder='form.enter last workplace'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.callsign'
            name='data.callsign'
            placeholder='form.enter callsign'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <MaskInput
            label='form.ogrnip'
            name='ogrnip'
            placeholder='form.enter ogrnip'
            readOnly={disabled}
            skeletonShow={skeletonShow}
            mask='#-##-##-#########-#'
          />
        </Grid>

        <Grid xs={12}>
          <TextareaInput
            label='form.comment'
            name='comment'
            placeholder='form.enter comment'
            sx={{
              height: '138px',
            }}
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
